import React from 'react';
import { Label } from '../ui/label';
import { DateTimePicker, tomorrowIso } from './DateTimePicker';

// "When did this happen?" — defaults to now; staff may pick any past date/time to record a milestone retrospectively.
export function OccurredAtField({ value, onChange, testId = 'occurred-at' }) {
  const custom = Boolean(value);
  const seg = 'px-3 py-1.5 rounded-[3px] text-sm transition-colors duration-[120ms] ';
  return (
    <div className="space-y-2" data-testid={testId}>
      <Label className="font-medium text-gray-700">When did this happen?</Label>
      <div className="inline-flex rounded-sm border border-gray-200 p-0.5 bg-gray-50">
        <button type="button" onClick={function () { onChange(''); }} className={seg + (!custom ? 'bg-white text-ink shadow-sm' : 'text-gray-600 hover:text-ink')} aria-pressed={!custom} data-testid={testId + '-now'}>Now</button>
        <button type="button" onClick={function () { if (!custom) onChange(new Date().toISOString()); }} className={seg + (custom ? 'bg-white text-ink shadow-sm' : 'text-gray-600 hover:text-ink')} aria-pressed={custom} data-testid={testId + '-custom'}>Choose date and time</button>
      </div>
      {custom && <DateTimePicker value={value} onChange={onChange} maxDate={tomorrowIso()} testId={testId + '-picker'} />}
      <p className="text-xs text-gray-500">Pick a past date to record a milestone that already took place — it appears on the tracking page at that date and time.</p>
    </div>
  );
}
